export const SUCustomHttpHeaders = {
    SerializeDatesHeader: "DateOnly",
}